import { render, staticRenderFns } from "./Osa002.vue?vue&type=template&id=2a7622ce&scoped=true"
var script = {}
import style0 from "./Osa002.vue?vue&type=style&index=0&id=2a7622ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7622ce",
  null
  
)

export default component.exports